import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { ButtonGroup, Button } from 'reactstrap';
import { useParams, Link } from "react-router-dom";
import GroupForm from '../GroupForm/GroupForm';
import { PageTitle, StudentListItem } from '../../../components';

import { loadGroup, updateGroup, toggleGroupStatus } from '../../../redux/modules/groups';
import { mdiAccountGroupOutline } from '@mdi/js';

const GroupEdit = props => {
    const { groupId } = useParams();

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(loadGroup(groupId));
    }, [ groupId ]);

    const { t }        = useTranslation();
    const { isLoading, group } = useSelector(state => state.groups);
    const current_user = useSelector(state => state.auth.user);

    if (!current_user || !group)
        return null;

    const submit = values => {
        dispatch(updateGroup(values));
    }

    const toggleGroupStatus = () => {
        dispatch(toggleGroupStatus(group));
    }

    const title =
        <span>
            {t('groups.group')}
            <small> | {t('groups.update_group', {name: group.name})}</small>
        </span>

    const actions = (
        <div>
            {group &&
            <ButtonGroup>
                <Button tag={Link} to={ -1 } color="warning" size="sm">
                    <i className="fa fa-arrow-left"></i>&nbsp;
                    {t('common.back')}
                </Button>
            </ButtonGroup>
            }
        </div>
    )

    return (
        <div className="GroupEdit">
            <PageTitle icon={mdiAccountGroupOutline} title={ title } actions={ actions } />

            {group &&
                <GroupForm groupId={group.id} onSubmit={submit} />
            }
        </div>
    );
}

export default GroupEdit;
